import { IconButton, makeStyles, Popover } from '@material-ui/core'
import React, { useState } from 'react'
import { getProductImageUrl } from 'utils/imageUtils'

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'auto',
  },
  paper: {
    padding: theme.spacing(2),
    maxWidth: 400,
    height: 'auto',
  },
  img: {
    width: '100%',
    cursor: 'pointer',
  },
}))

interface ImagePopoverProps {
  variant: 'iconPopover' | 'imagePopover'
  imageComponent?: React.ReactElement
  imageId?: string
}

const ImagePopover: React.FC<ImagePopoverProps> = ({ variant, imageComponent, imageId }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [selectedImg, setSelectedImg] = useState<string>('')

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    const imgSrc = getProductImageUrl(imageId)
    setSelectedImg(imgSrc)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const handlePopoverExited = () => {
    setSelectedImg('')
  }

  const open = Boolean(anchorEl)

  return (
    <>
      {variant === 'imagePopover' ? (
        <div style={{ cursor: 'pointer' }} onClick={handlePopoverOpen}>
          {imageComponent}
        </div>
      ) : (
        <IconButton
          aria-owns={open ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          className="card-img-popover"
          onClick={handlePopoverOpen}
        >
          <i className="fa-light fa-image"></i>
        </IconButton>
      )}

      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        TransitionProps={{ onExited: handlePopoverExited }}
        disableRestoreFocus={false}
      >
        <img src={selectedImg} alt="Detail" className={classes.img} />
      </Popover>
    </>
  )
}

export default ImagePopover
